import React from "react";
import { NavBar, Icon, List, Drawer } from "antd-mobile";
import { getCodeTableListByProductCode, getLog } from "../../ajax/index.js";

import { createHashHistory } from "history";
import { Link } from "react-router-dom";
const history = createHashHistory();

const Item = List.Item;
class MenuList extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      open: false, //抽屉隐藏状态
      open2: false,
      MenuListDatatwo: [], //二级分类数组
      MenuListDatathree: [], //三级分类数组
      indexid: 1,
      codeTableData: [],
      language: "",
    };
  }
  componentDidMount() {
    //获取分类列表
    let id = this.props.match.params.id.split(",")[0];
    let language = this.props.match.params.id.split(",")[1];
    this.setState({
      language: language,
    });

    //发送埋点日记
    // let currentUrl = window.location.href;
    // let appId = 'tsp.errorcode';
    // let pointName = '/categorylist';
    // getLog(currentUrl, appId, pointName);

    getCodeTableListByProductCode(id, language).then((res) => {
      if (res.data && res.data.length > 0) {
        let data = res.data;
        data.forEach((v) => {
          v.categoryNamesList = v.categoryNames.join(">");
        });
        this.setState({
          codeTableData: data, //故障表
        });

        let h = document.getElementById("my-list").offsetHeight;
        let bodyh = document.body.clientHeight;
        // console.log(h, 'height', bodyh)
        let height = bodyh - h;

        document.getElementById("hidenbtnWrap").style.height = height + "px";
      } else {
        this.props.history.push("/systemerror");
      }
    });

    // let jj = a.offsetHeight + a.offsetTop;
    // let bodyHeight = document.body.clientHeight;
    // let tableHeight = bodyHeight - t - 70 - num;
  }
  //抽屉展示隐藏
  //   onOpenChange = (id, listId) => {
  //     // console.log(this.state.indexid, id, '888888888888888888888');
  //     if (this.state.indexid === id) {
  //       this.setState({
  //         open: !this.state.open,
  //       });
  //     } else {
  //       this.setState({
  //         open: true,
  //       });
  //     }
  //     this.setState({
  //       MenuListDatathree: [], //二级分类数组
  //       indexid: id,
  //     });

  //     //根据listId获取分类列表
  //     let language = this.props.match.params.id.split(",")[1];
  //     getMenuList(id, language).then((res) => {
  //       if (res.data.length < 1) {
  //         if (listId === "") {
  //           this.props.history.push("/systemerror");
  //         } else {
  //           this.props.history.push("/errorCodeTable/" + listId + "," + language);
  //         }
  //         // this.setState({
  //         //     open: false,
  //         // });
  //       } else {
  //         this.setState({
  //           MenuListDatathree: res.data,
  //         });
  //       }
  //       setTimeout(function () {
  //         [...document.getElementsByClassName("list-cont")].map((item) => {
  //           if (item) {
  //             let _p = item.parentNode;
  //             let _h = _p.clientHeight;
  //             if (_h > 51) {
  //               _p.className = "autoHeightli";
  //             }
  //           }
  //         });
  //       }, 100);
  //     });
  //   };
  //返回上一页
  back() {
    history.goBack();
  }
  //点击列表以外的地方收起抽屉
  //   Hidenbtn = () => {
  //     this.setState({
  //       open: false,
  //     });
  //   };
  render() {
    // changeMeta(this.props.match.path);
    //根据id判断title
    let title = "CodeTableList";
    let buId = this.props.match.params.id.split(",")[0];
    let language = this.props.match.params.id.split(",")[1];
    return (
      <div className="transition-item detail-page">
        <div className="menu-style ">
          <NavBar
            mode="light"
            icon={<Icon type="left" />}
            onLeftClick={this.back}
          >
            {title}
          </NavBar>
          <div className="content">
            <List className="my-list2" id="my-list">
              {/* 二级分类  autoHeightli*/}
              {this.state.codeTableData.map((i, key2) => {
                return (
                  <div className="codeTable_item">
                    <div className="codeCategoryTitle">
                      {i.categoryNamesList}
                    </div>
                    <div>
                      {i.errorCodeLists.map((t, key) => {
                        return (
                          <Item>
                            <Link
                              to={
                                "/errorCodeTable/" +
                                t.id +
                                "," +
                                language +
                                "," +
                                buId
                              }
                              key={t.id}
                            >
                              <div>{t.name}</div>
                            </Link>
                          </Item>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </List>
            <div
              className="hidenbtn"
              id="hidenbtnWrap"
              onClick={this.Hidenbtn}
            ></div>
          </div>
        </div>
      </div>
    );
  }
}
export default MenuList;



// WEBPACK FOOTER //
// ./src/pages/search/errorCodeListByProduct.js